import { render, staticRenderFns } from "./UpPicture.vue?vue&type=template&id=32905d8f&scoped=true&"
import script from "./UpPicture.vue?vue&type=script&lang=js&"
export * from "./UpPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32905d8f",
  null
  
)

export default component.exports